import { render, staticRenderFns } from "./ForceUpdateSDKConfigForm.vue?vue&type=template&id=0c24df44&scoped=true"
import script from "./ForceUpdateSDKConfigForm.vue?vue&type=script&lang=js"
export * from "./ForceUpdateSDKConfigForm.vue?vue&type=script&lang=js"
import style0 from "./ForceUpdateSDKConfigForm.vue?vue&type=style&index=0&id=0c24df44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c24df44",
  null
  
)

export default component.exports